// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see FeatureRestrictionBannerViewImpressionEvent
 */
export var FeatureRestrictionBannerViewImpression = function (_a) {
    var location = _a.location, bannerText = _a.bannerText;
    return ({
        name: "FeatureRestrictionBanner View Impression",
        parameters: {
            cdf_entity: "FeatureRestrictionBanner",
            cdf_action: "View",
            location: location !== undefined && location !== null ? location.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            banner_text: bannerText !== undefined && bannerText !== null ? bannerText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FeatureRestrictionBannerInteractTapEvent
 */
export var FeatureRestrictionBannerInteractTap = function (_a) {
    var location = _a.location, action = _a.action, actionText = _a.actionText, actionLocation = _a.actionLocation, bannerText = _a.bannerText;
    return ({
        name: "FeatureRestrictionBanner Interact Tap",
        parameters: {
            cdf_entity: "FeatureRestrictionBanner",
            cdf_action: "Interact",
            location: location !== undefined && location !== null ? location.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action_text: actionText !== undefined && actionText !== null ? actionText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action_location: actionLocation !== undefined && actionLocation !== null ? actionLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            banner_text: bannerText !== undefined && bannerText !== null ? bannerText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
